import { render, staticRenderFns } from "./flashSale.vue?vue&type=template&id=8b3c30e8&scoped=true"
import script from "./flashSale.vue?vue&type=script&lang=js"
export * from "./flashSale.vue?vue&type=script&lang=js"
import style0 from "./flashSale.vue?vue&type=style&index=0&id=8b3c30e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3c30e8",
  null
  
)

export default component.exports